import playerClient from "../middleware/playerClient";
import publicAppsClient from "../middleware/publicAppsClient";

export const MATKA_MARKETS_ENDPOINT = "matka/markets";

export async function fetchMatkaMarkets() {
  const response = await publicAppsClient.get(MATKA_MARKETS_ENDPOINT);
  const markets = response.data?.data;
  if (!response.data?.success || !Array.isArray(markets)) {
    throw new Error("Unable to load markets");
  }
  return markets;
}

export const MATKA_SUGGESTIONS_ENDPOINT = "matka/suggestions";

export async function fetchMatkaSuggestions(betTypeCode, digits) {
  const response = await publicAppsClient.get(MATKA_SUGGESTIONS_ENDPOINT, {
    params: {
      bet_type_code: betTypeCode,
      digits,
    },
  });
  const suggestions = response.data?.data;
  if (!response.data?.success || !suggestions) {
    throw new Error("Unable to load suggestions");
  }
  return suggestions;
}

export async function fetchMatkaMarket(marketId) {
  const response = await publicAppsClient.get(`${MATKA_MARKETS_ENDPOINT}/${marketId}`);
  const market = response.data?.data;
  if (!response.data?.success || !market) {
    throw new Error("Unable to load market");
  }
  return market;
}

export async function fetchMatkaDailyResults(date) {
  const response = await publicAppsClient.get("matka/results/daily", {
    params: date ? { date } : undefined,
  });
  const results = response.data?.data;
  if (!response.data?.success || !results) {
    throw new Error("Unable to load results");
  }
  return results;
}

export async function placeMatkaBet({
  marketId,
  betTypeCode,
  session,
  selections,
  idempotencyKey,
}) {
  const response = await playerClient.post("matka/bets", {
    market_id: Number(marketId),
    bet_type_code: betTypeCode,
    session,
    idempotency_key: idempotencyKey,
    selections,
  });
  const bet = response.data?.data;
  if (!response.data?.success || !bet) {
    throw new Error("Unable to place the bet");
  }
  return bet;
}

export async function fetchMatkaBets({
  page = 1,
  limit = 20,
  status,
  marketId,
  batchId,
  betTypeCode,
  session,
  betDate,
  dateFrom,
  dateTo,
} = {}) {
  const params = { page, limit };
  if (status) params.status = status;
  if (marketId) params.market_id = marketId;
  if (batchId) params.batch_id = batchId;
  if (betTypeCode) params.bet_type_code = betTypeCode;
  if (session) params.session = session;
  if (betDate) params.bet_date = betDate;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;

  const response = await playerClient.get("matka/bets", { params });
  const bets = response.data?.data;
  if (!response.data?.success || !Array.isArray(bets)) {
    throw new Error("Unable to load bets");
  }
  return {
    bets,
    pagination: response.data.pagination || null,
  };
}

export async function fetchMatkaBetBatch(batchId) {
  const response = await playerClient.get(`matka/bets/${batchId}`);
  const batch = response.data?.data;
  if (!response.data?.success || !batch) {
    throw new Error("Unable to load bet");
  }
  return batch;
}

export async function fetchMatkaMonthlyResults(marketId, month, year) {
  const response = await publicAppsClient.get(
    `${MATKA_MARKETS_ENDPOINT}/${marketId}/results/monthly`,
    { params: { month, year } }
  );
  const results = response.data?.data;
  if (!response.data?.success || !results) {
    throw new Error("Unable to load results");
  }
  return results;
}
